module.exports = __webpack_public_path__ + "img/sennebogen_blue.856489f6.svg";